module.exports = __webpack_public_path__ + "img/no_user_data.02d08842.svg";